import { useEffect, useState } from "react";
import { _ErrorDetails, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { SelectSeverityLevels } from "../../SeverityLevels/SelectSeverityLevels";
import { SelectMaintenanceTypeItem } from "../../MaintenanceTypeItem/SelectMaintenanceTypeItem";


interface Props {
    idErrorType: number;
}

export const ErrorDetails = ({ idErrorType }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ErrorDetails);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (idErrorType) {
            getLista();
        }
    }, [idErrorType])

    const getLista = () => {
        const props = {
            State: 1,
            IDErrorTypes: idErrorType
        }
        instance.getErrorDetailsCatalogPorPropiedades(props, null).then((resp: any) => {
            setLista(resp);
        }).catch(err => {
            toast.error("Error al cargar la lista de errores");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDErrorTypes: idErrorType
        });
        setModal({ ...modal, "name": `Agregar Error`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateErrorDetails(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'IDErrorDetails', property: 'IDErrorDetails', visible: true },
        { title: 'Codigo de Error', property: 'CodeError', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Prioridad', property: 'RenderSeverity', visible: true },
        { title: 'Mantenimiento Asociado', property: 'RenderIDCategory', visible: true },
        { title: 'Causa', property: 'Cause', visible: true },
        { title: 'Acción Correctiva', property: 'CorrectiveAction', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "Name"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('CodeError') ? 'has-error' : ''}`} >Código de Error</label>
                            <input type="text" className="form-control" value={bean.CodeError} onChange={(e) => { setBean({ ...bean, CodeError: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectSeverityLevels returnType="Object" idSelector={bean.IDSeverity} onChange={(e) => { setBean({ ...bean, IDSeverity: e?.IDSeverityLevels, RenderSeverity: e?.Name }) }} label="Nivel de Severidad" />
                        </div>
                        <div className="col-md-6">
                            <SelectMaintenanceTypeItem idSelector={bean.IDMaintenanceTypeMachine} onChange={(e: any) => { setBean({ ...bean, IDCategory: e?.IDMaintenanceTypeItem, RenderIDCategory: e?.Name }); }} returnType="Object" label="Categoria" />
                        </div>
                        <div className="col-md-12">
                            <label>Causa del Error</label>
                            <textarea value={bean.Cause} onChange={(e) => { setBean({ ...bean, Cause: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label>Acción Correctiva</label>
                            <textarea value={bean.CorrectiveAction} onChange={(e) => { setBean({ ...bean, CorrectiveAction: e.target.value }) }} className="form-control" />
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.TechnicianName}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}